<template>
  <v-app id="inspire">
    <template>
      <v-toolbar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        color="primary"
        dark
        app
        fixed>
        <v-toolbar-title
          style="width: 300px"
          class="ml-0 pl-3"
          @click="$router.push({ name: 'home' })">

          <span
            class="hidden-sm-and-down"
            style="cursor: pointer"
          >
            Elsazeit
          </span>

        </v-toolbar-title>
        <v-spacer/>

        <v-menu
          left
          class="mr-0 pr-3"
        >
          <v-btn
            slot="activator"
            flat
            icon
          >
            {{ this.$i18n.locale }}
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="language in languagesList"
              :key="language.id"
              @click="setI18nLanguage(language.name)"
            >
              <v-list-tile-title>{{ languageNames[language.name] }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

      </v-toolbar>
    </template>

    <v-content>
      <v-container fluid>
        <v-layout
          align-center
          justify-center>
          <slot/>
          <global-notifications/>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import GlobalNotifications from '@/components/layouts/parts/GlobalNotifications'
import setLayoutClass from '@/utils/setLayoutClass'
import '@/styles/webapp/app.scss'
import { mapGetters } from 'vuex'
import { setI18nLanguage } from '../../locales/i18n-setup'

export default {
  name: 'DemoLayout',
  components: { GlobalNotifications },
  data () {
    return {
      languageNames: {
        en: 'English',
        ru: 'Русский',
        de: 'Deutsch',
        tr: 'Türkçe'
      }
    }
  },
  computed: {
    ...mapGetters('languages', ['languagesList'])
  },
  methods: {
    setI18nLanguage: setI18nLanguage
  },
  mounted () {
    setLayoutClass('layout-webapp')
    setI18nLanguage(typeof localStorage.locale === 'undefined' ? 'de' : localStorage.locale)
  },
  i18n: {
    messages: {
      de: {
        errorWhileLoadingTranslations: 'Konnte Übersetzungen nicht laden'
      },
      tr: {
        errorWhileLoadingTranslations: 'Çeviriler yüklenemedi'
      },
      en: {
        errorWhileLoadingTranslations: 'Could not load translations'
      },
      ru: {
        errorWhileLoadingTranslations: 'Не удалось загрузить переводы'
      }
    }
  }
}
</script>
